import TableSearch from '../TableSearch';
import React from 'react';
import { Spin, Table, Tabs } from 'antd';


class TableHelper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      queryData: {},
      tabsData: {},
      pagination: {
        current: 1,
        pageSize: 10,
      },
      dataSource: [],
      total: 0,
    };
  }

  componentDidMount() {
    if (this.props.getRef) {
      this.props.getRef(this);
    }
    if (this.props.initialValue && this.props.searchOptions) {
        this.TableSearchRef.setFormData(this.props.initialValue)
        this.setState(state => {
            state.queryData = {...state.queryData, ...this.props.initialValue}
            return state
        }, () => this.postDataSource())
    } else {
        this.postDataSource();
    }
    
  }

  handleQuery = (e) => {
    this.setState(
      {
        queryData: e,
        pagination: { current: 1, pageSize: 10 },
      },
      () => this.postDataSource()
    );
  };

  handleTabsChange = (e, key) => {
    this.setState(state => {
        state.tabsData[key] = e
        state.pagination = { current: 1, pageSize: 10 }
        return state
    }, () => this.postDataSource())
  }

  handleChange = (e) => {
    this.setState(
      (state) => {
        state.pagination.current = e.current;
        return state;
      },
      () => this.postDataSource()
    );
  };

  parseResponse(res) {
    const { total, records } = res;
    return { total, dataSource: records };
  }

  parseRequestData(res) {
    return res;
  }

  postDataSource() {
    const data = {
      ...this.state.queryData,
      ...this.state.tabsData,
      ...this.state.pagination,
    };

    this.setState({ loading: true });
    const parseRequestData =
      this.props.parseRequestData || this.parseRequestData;
    this.props
      .request(parseRequestData(data))
      .then((res) => {
        const parse = this.props.parseResponse || this.parseResponse;
        this.setState(parse(res));
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  renderSlot(slotName) {
    const { children } = this.props;
    if (!children) return [];
    const result = [];
    if (Array.isArray(children)) {
      result.concat(children);
    } else {
      result.push(children );
    }
    return result.filter((e) => {
      return e.props.slot === slotName;
    });
  }

  render() {
    const pagination = {
      total: this.state.total,
      size: 'default',
      pageSize: this.state.pagination.pageSize,
      current: this.state.pagination.current,
      showTotal: () => '共' + this.state.total + '条',
      onShowSizeChange: (current, pageSize) => {
        this.setState({ pagination: { current, pageSize } }, () =>
          this.postDataSource()
        );
      },
    };

    return (
      <Spin spinning={this.state.loading}>
        {this.props.tabsOptions && (
            this.props.tabsOptions.map(e => {
                return (
                    <Tabs defaultActiveKey="" onChange={(ee) => this.handleTabsChange(ee, e.key)}>
                        <Tabs.TabPane tab="全部" key="" />
                        {e.options.map(item => <Tabs.TabPane tab={item.title} key={item.value} />)}
                    </Tabs>
                )
            })
            
        )}
        {this.props.searchOptions && (
          <TableSearch
            ref={ref => this.TableSearchRef = ref}
            options={this.props.searchOptions}
            onSubmit={this.handleQuery}
          >
            {this.renderSlot('search')}
          </TableSearch>
        )}
        {this.renderSlot('mid')}
        <Table
          style={{ marginTop: 16 }}
          rowKey="id"
          bordered={this.props.bordered}
          columns={this.props.columns || []}
          dataSource={this.state.dataSource || []}
          pagination={pagination}
          onChange={this.handleChange}
          scroll={this.props.scroll}
          {...this.props.tableProps}
        />
      </Spin>
    );
  }
}

export default TableHelper;



// WEBPACK FOOTER //
// ./src/components/TableHelper/index.jsx